import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import MainLink from "../Link";

function ShopPagePay({ onClose }) {
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [currency, setCurrency] = useState("RUB");
    const [amount, setAmount] = useState("");
    const [isAmountValid, setIsAmountValid] = useState(true);
    const [courses, setCourses] = useState([]);
    const [totalPrice, setTotalPrice] = useState("");

    useEffect(() => {
        const getCourses = async () => {
            try {
                const response = await fetch(`${MainLink()}api/payments/get-courses`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                });
                if (!response.ok) throw new Error(`Ошибка загрузки данных: ${response.status}`);
                const result = await response.json();
                setCourses(result);
            } catch (error) {
                console.error(error);
            }
        };
        getCourses();
    }, []);

    const payments_url = `${MainLink()}api/payments/add-payment`;

    const submit_payment = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());

        try {
            const response = await fetch(payments_url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error(`Ошибка загрузки предмета: ${response.status}`);
            const result = await response.json();

            if (result.code == "200") {
                const link = `https://pay.fk.money/?m=56847&oa=${result.object[1]}&currency=${payload.money_currency}&o=${payload.target_user}&s=${result.object[0]}`;
                window.location.href = link;
            }
        } catch (err) {
            console.error("Ошибка загрузки данных:", err.message);
        }
    };

    const handleCurrencyChange = (e) => {
        const newCurrency = e.target.value;
        setCurrency(newCurrency);
        if (newCurrency === "KZT" && parseInt(amount) < 10) {
            setIsAmountValid(false);
        } else {
            setIsAmountValid(true);
        }

        if (amount !== "0") {
            let totalAmount = 0;
            courses.forEach((course) => {
                if (course.currency === newCurrency) {
                    totalAmount = amount / course.donateCoins;
                }
            });
            setTotalPrice(totalAmount.toFixed(2));
        }
    };

    const handleAmountChange = (e) => {
        let value = e.target.value.replace(/\D/g, "");
        if (value === "0") value = "";
        setAmount(value);

        let totalAmount = 0;
        courses.forEach((course) => {
            if (course.currency === currency) {
                totalAmount = value / course.donateCoins;
            }
        });
        setTotalPrice(totalAmount.toFixed(2));

        if (currency === "KZT" && parseInt(value) < 10 && value !== "") {
            setIsAmountValid(false);
        } else {
            setIsAmountValid(true);
        }
    };

    return (
        <AnimatePresence>
            {isModalOpen && (
                <motion.div
                    className="modal"
                    initial={{ y: -600, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -600, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                >
                    <motion.div
                        className="modal-content"
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <button className="modal-close" onClick={() => { setIsModalOpen(false); onClose && onClose(); }}>
                            &times;
                        </button>
                        <h2>СПОСОБЫ ОПЛАТЫ</h2>
                        <form onSubmit={submit_payment}>
                            <input type="text" name="target_user" placeholder="Логин" minLength={3} required />
                            <select className="select-currency" name="money_currency" value={currency} onChange={handleCurrencyChange}>
                                <option value="RUB">RUB</option>
                                <option value="USD">USD</option>
                                <option value="EUR">EUR</option>
                                <option value="UAH">UAH</option>
                                <option value="KZT">KZT</option>
                            </select>
                            <input
                                name="donate_coins"
                                type="text"
                                placeholder="Количество MD коинов"
                                value={amount}
                                onInput={handleAmountChange}
                                required
                            />
                            <div className="select-currency div-courses">
                                СУММА: {totalPrice} {totalPrice > 0 ? currency : ""}
                            </div>
                            {!isAmountValid && currency === "KZT" && (
                                <div style={{ color: "red" }}>Минимальная сумма для KZT: 10</div>
                            )}
                            <button className="modal-button" type="submit" disabled={!isAmountValid || amount.length < 1}>ПОПОЛНИТЬ</button>
                        </form>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export const ShopPay = (props) => <ShopPagePay {...props} />;